import React from 'react';
import { Field } from './Field';
import { describedBy, inputClass } from '../../utils/styles';
type TextFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  hint?: string;
  error?: string;
  type?: 'text' | 'email' | 'url';
  autoComplete?: string;
  placeholder?: string;
  className?: string;
};
export function TextField({
  id,
  label,
  value,
  onChange,
  required = false,
  hint,
  error,
  type = 'text',
  autoComplete,
  placeholder,
  className
}: TextFieldProps) {
  return <Field id={id} label={label} required={required} hint={hint} error={error} className={className} data-id="element-91" data-mp="1sth5na1ngccu">
      <input id={id} name={id} type={type} value={value} autoComplete={autoComplete} placeholder={placeholder} onChange={e => onChange(e.target.value)} aria-required={required} aria-invalid={Boolean(error)} aria-describedby={describedBy(id, Boolean(hint), Boolean(error))} className={inputClass(Boolean(error))} data-id="element-92" data-mp="1isx0vxex8ppv" />
    </Field>;
}